module.exports = __webpack_public_path__ + "img/default.f6aa4028.svg";